import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ResourceImageInfoDto } from './ResourceImageInfoDto'
/**
* Class ResourceRef
*  Информация о файле-ресурсе
*/
export class ResourceRef extends ActiveModel {

/**
  * id
  * Идентификатор связанных данных<br>
  */
  @ActiveField('')
  id: string = ''


/**
  * displayName
  * Название связанных данных<br>
  */
  @ActiveField()
  displayName?: null | string


  /**
  * imageInfo
  * Информация о файле-изображении  */
  @ActiveField({
    factory: [ResourceImageInfoDto, () => null]
  })
  imageInfo: null | ResourceImageInfoDto = null
}
